import type { MediaAlternative, MediaSummary } from '../../shared/contracts'

export function normalizeMediaTitle(value: string) {
    return value.replace(/[\s·:：,，.。!！?？\-_]/gu, '').toLocaleLowerCase()
}

function mediaKey(item: Pick<MediaSummary, 'sourceId' | 'id'>) {
    return `${item.sourceId}:${item.id}`
}

function alternativeOf(item: MediaSummary): MediaAlternative {
    return {
        id: item.id,
        sourceId: item.sourceId,
        sourceName: item.sourceName,
        episodeCount: item.episodeCount,
    }
}

export function mergeMediaResults(groups: MediaSummary[][]): MediaSummary[] {
    const merged = new Map<string, MediaSummary>()

    for (const item of groups.flat()) {
        const title = normalizeMediaTitle(item.title)
        const groupKey = `${title}\u0000${item.year || ''}`
        const existing = merged.get(groupKey)
        if (!existing) {
            merged.set(groupKey, { ...item, alternatives: [...(item.alternatives || [])] })
            continue
        }

        const alternatives = new Map<string, MediaAlternative>()
        for (const alternative of [...(existing.alternatives || []), alternativeOf(item), ...(item.alternatives || [])]) {
            if (mediaKey(alternative) !== mediaKey(existing)) { alternatives.set(mediaKey(alternative), alternative) }
        }
        existing.alternatives = [...alternatives.values()]
        existing.backdrop ||= item.backdrop
        existing.poster ||= item.poster
        existing.description ||= item.description
        existing.score ||= item.score
        existing.runtime ||= item.runtime
        existing.category ||= item.category
        existing.episodeCount ||= item.episodeCount
    }

    return [...merged.values()]
}

export function heroQuality(item: MediaSummary) {
    return Number(Boolean(item.backdrop)) * 5
        + Number(Boolean(item.description)) * 2
        + Number(Boolean(item.score))
        + Number(Boolean(item.year))
}
